// All avatars are local - no external API calls at runtime.
const AVATAR_COUNT = 34;
export const AVATAR_SEEDS: string[] = Array.from(
  { length: AVATAR_COUNT },
  (_, index) => `avatar${index + 1}`,
);

export function seedToUrl(seed: string): string {
  return `assets/avatars/${seed}.svg`;
}

export function getDefaultAvatarUrl(name: string): string {
  let h = 0;
  for (let i = 0; i < name.length; i++) {
    h = (Math.imul(31, h) + (name || "stranger").charCodeAt(i)) | 0;
  }
  const seed = AVATAR_SEEDS[Math.abs(h) % AVATAR_SEEDS.length];
  return seedToUrl(seed);
}
